import Chip from '@/atoms/chips/Chip';
import EntityChip from '@/atoms/chips/EntityChip';
import Paragraph from '@/atoms/typography/Paragraph';
import Size from '@enums/Size';
import Stack from '@mui/material/Stack';

const propertyColorProps = (color) => {
  return {
    normal: {
      backgroundColor: color.primary,
      color: color.tertiary,
    },
    focus: {
      backgroundColor: color.primary,
      color: color.tertiary,
    },
    hover: {
      backgroundColor: color.primary,
      color: color.tertiary,
    },
  };
};

const PropertyLabel = ({ item }) => {
  const { label, type, props } = item;

  const colors = props.color || props.colors;
  const colorProps = colors ? propertyColorProps(colors) : null;
  const parentEntity = item.parentType || props.parent?.type;

  return (
    <>
      <Stack direction="row" spacing={0.5}>
        {props.scope && <EntityChip type={props.scope} size={Size.XX_SMALL} />}
        {parentEntity && (
          <EntityChip type={parentEntity} size={Size.XX_SMALL} />
        )}
        {props.parent && (
          <Chip
            id={item.id}
            colorProps={colorProps}
            name={props.parent.name.toUpperCase()}
            size={Size.XX_SMALL}
            fontWeight={600}
          />
        )}
      </Stack>
      <Paragraph size={Size.SMALL} overrideStyles={{ mb: 0, mt: 0.75 }}>
        {label}
      </Paragraph>
    </>
  );
};

export default PropertyLabel;
